export default __webpack_public_path__ + "static/media/share-inactive.0d0da6b5.svg";